// extracted by mini-css-extract-plugin
export default {"noData":"Chart_noData__V5pzr"};